import { ImageAsset } from "@/components/ImageAsset";
import { useBand } from "@/lib/api";
import { responsiveImage } from "@/lib/helper";
import { basierCirleBold } from "@/styles/fonts";
import theme from "@/styles/theme";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "next/link";

export default function EventBandDetails({ band }) {
  const { band: bandData } = useBand(band.slug);

  return (
    <>
      {band.photo?.formats && (
        <Grid item xs="auto" sx={bandImageStyles}>
          <Box className="band-image-circle">
            <ImageAsset
              url={responsiveImage(band?.photo?.formats, 600)}
              layout="fill"
            />
          </Box>
        </Grid>
      )}
      <Grid item xs sx={bandNameStyles}>
        <Box sx={{ marginLeft: "0.5rem" }}>
          <Typography className="band-name">
            <Link href={`/musik/${band.slug}`}>{band.name}</Link>
          </Typography>
          <Typography className="band-genre-zipcode">
            <span>
              {bandData?.genres[0].title}
              {" aus "}
              {bandData?.zipcode?.label}
            </span>
          </Typography>
        </Box>
      </Grid>
    </>
  );
}

const bandImageStyles = {
  position: "relative",

  "& .band-image-circle": {
    width: "1.5rem",
    aspectRatio: "1 / 1",
    [theme.breakpoints.up("sm")]: {
      width: "2rem",
    },
    "& img": {
      borderRadius: "50%",
    },
  },
};

const bandNameStyles = {
  "& .band-name": {
    fontSize: "0.85rem",
    fontFamily: basierCirleBold.style.fontFamily,
    fontWeight: basierCirleBold.style.fontWeight,
    transition: "color 0.3s ease-in-out",
    textTransform: "uppercase",
    lineHeight: "0.85",
    width: "fit-content",
    [theme.breakpoints.up("md")]: {
      fontSize: "1rem",
    },
    "&:hover": {
      color: theme.palette.primary.main,
    },
    "& a": {
      color: "inherit",
      textDecoration: "none",
      display: "block",
    },
  },
  "& .band-genre-zipcode": {
    fontSize: "0.625rem",
    textTransform: "uppercase",
    [theme.breakpoints.up("md")]: {
      fontSize: "0.75rem",
    },
  },
};
